import {useState, useCallback} from 'react';
import {useRouteMatch} from 'react-router-dom';
import {Grid} from 'semantic-ui-react';

import GeneralInfo from 'components/Common/GeneralInfo/GeneralInfo';

import UPDComponent from './UPDComponent/UPDComponent';

import styles from './WebEOSSite.module.scss';

const WebEOSSite = () => {
  let {
    params: {projectName},
  } = useRouteMatch();

  const [webEOSSites, setWebEOSSites] = useState([]);
  const [category, onCategoryChange] = useState();
  const [ownerInfo, onOwnerInfoChange] = useState();

  const onWebEOSSites = useCallback(values => {
    setWebEOSSites(values);
  }, []);

  const message = (
    <>
      You are about to delete the project "<strong>{projectName}</strong>" with all its sites:
      <ul>
        {webEOSSites.map(site => (
          <li key={site}>{site}</li>
        ))}
      </ul>
      This operation cannot be undone. Are you sure that you want to proceed? Please note that:
      <ul>
        <li>It may take some time for the URL(s) to be available for reuse again.</li>
        <li>
          In case you have registered your site for <strong>Web Analytics</strong> and you don't
          need the analytics data anymore, you can request the deletion of the Matomo registration
          via a{' '}
          <a
            className={styles.Link}
            href="https://cern.service-now.com/service-portal?id=sc_cat_item&name=request&fe=web-infrastructure"
            target="_blank"
            rel="noreferrer"
          >
            SNOW ticket
          </a>
          .
        </li>
      </ul>
    </>
  );

  return (
    <>
      <Grid centered>
        <Grid.Column className={styles.WebEOSSite}>
          <GeneralInfo
            projectName={projectName}
            projectType="webeos"
            removeProjectMessage={message}
            onCategoryChange={onCategoryChange}
            onOwnerInfoChange={onOwnerInfoChange}
          />
          <UPDComponent
            projectName={projectName}
            category={category}
            ownerInfo={ownerInfo}
            onWebEOSSites={onWebEOSSites}
          />
        </Grid.Column>
      </Grid>
    </>
  );
};

export default WebEOSSite;
